import {useSelector} from 'react-redux';
import {TwoParamsOption} from '../../../components/grid-dx/types';
import authFetch from '../../../helpers/requests';

function useSendDataToBack() {
  const finishAttended = useFinishedAttended(
    'api/Attended/AttendedCompleteInPerson',
  );
  return (onlyTwoParamsOptions: TwoParamsOption) =>
    finishAttended(onlyTwoParamsOptions);
}

function useFinishedAttended(url: string) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return async (onlyTwoParamsOptions: TwoParamsOption) => {
    const values = {
      ...onlyTwoParamsOptions.AddedOne,
      ...onlyTwoParamsOptions.AddedTwo,
    };

    try {
      const response = await authFetch(
        `${url}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify(JSON.stringify(values)),
        },
        token,
      );
      return response;
    } catch (e) {
      return {};
    }
  };
}

export default useSendDataToBack;
